/** Custom domain helpers for public shop storefront. */
export const APP_HOSTS = ['app.starsender.online', 'localhost', '127.0.0.1'];

export function isCustomDomain() {
  const h = (window.location.hostname || '').toLowerCase();
  return h && !APP_HOSTS.includes(h);
}

export function currentHostname() {
  return (window.location.hostname || '').toLowerCase();
}

/** Build shop URL path — root paths on custom domain, /toko/:slug otherwise. */
export function shopPath(slug, subPath = '') {
  const p = subPath.startsWith('/') ? subPath : (subPath ? `/${subPath}` : '');
  if (isCustomDomain()) return p || '/';
  return `/toko/${slug}${p}`;
}

export async function resolveCustomDomainShop(apiBase) {
  if (!isCustomDomain()) return null;
  const base = (apiBase || '').replace(/\/api\/v1\/?$/, '');
  const url = `${base}/api/public/shop/by-domain?domain=${encodeURIComponent(currentHostname())}`;
  const r = await fetch(url, { headers: { Accept: 'application/json' } });
  if (!r.ok) return null;
  const json = await r.json();
  return json?.data?.shop || null;
}
